import React from 'react';
import { AlertTriangle, CheckCircle, XCircle } from 'lucide-react';
import { Badge } from './ui/Badge';
interface GuardrailsIndicatorProps {
  label: string;
  value: number;
  limit: number;
  type: 'percent' | 'currency';
  inverse?: boolean; // if true, lower is better (default)
}
export function GuardrailsIndicator({
  label,
  value,
  limit,
  type,
  inverse = true
}: GuardrailsIndicatorProps) {
  const isCompliant = inverse ? value <= limit : value >= limit;
  const isWarning = inverse ? value > limit * 0.9 && value <= limit : value < limit * 1.1 && value >= limit;
  const formattedValue = type === 'percent' ? `${value.toFixed(2)}%` : new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  }).format(value);
  let variant: 'success' | 'warning' | 'destructive' = 'success';
  let Icon = CheckCircle;
  if (!isCompliant) {
    variant = 'destructive';
    Icon = XCircle;
  } else if (isWarning) {
    variant = 'warning';
    Icon = AlertTriangle;
  }
  return <div className="flex items-center justify-between py-1" data-id="element-45">
      <span className="text-sm text-slate-600" data-id="element-46">{label}</span>
      <Badge variant={variant} className="flex items-center gap-1" data-id="element-47">
        <Icon className="h-3 w-3" data-id="element-48" />
        {formattedValue}
      </Badge>
    </div>;
}